<template>
	<div
		class="d-flex flex-column d-lg-flex flex-lg-column flex-xl-row justify-content-lg-between px-lg-0 align-items-lg-center position-relative"
	>
		<div
			class="col-12 col-xl-6 px-0 d-flex flex-column nowrap align-items-start"
		>	
		<div class="d-flex flex-column flex-lg-row nowrap text-grey-900" v-if="specialStay">
				<span
					v-if="store.state.packCode !== 'HS'"
					class="me-4 text-nowrap caption"
				>
					<div class="caption-strong text-grey-900 mt-1">
						{{ store.state.content.planner_shortStay_rate }}
						<span v-if="(props.variant.codePackage === 'PFTTF' || props.variant.codePackage === 'PFPTTF') && props.variant.skipass">
							{{ props.variant.skipass }}
						</span>
						{{ store.state.content.days }}
					</div>
					<span class="me-1">{{
						store.state.content.planner_prestationsInclude
					}}</span>
					<svg class="icon info-icon tf-icon-10 tf-icon-sm-20">
						<use xlink:href="#___icon___info"></use>
					</svg>
					:
					<template v-if="store.getters.packageInfoContent[0]">
						<PackageDetalisPopUp>
							<span v-for="(content, content_i) in store.getters.packageInfoContent" :key="`${content[0]}-${content_i}}`">{{ content }}</span>
						</PackageDetalisPopUp>
					</template>
				</span> 

				<div class="d-flex flex-column flex-lg-row align-items-start">
					<Inclus
						:isDisplayPlaceholders="false"
						:variant="variant"
						class="mb-3 mb-lg-0 me-lg-4"
					/>
					<PaymentCondition v-if="specialStay" :paymentCondition="props.variant.paymentCondition" :cancellation-date="variant.cancelationUntil" :displayTitle="true" :isPVFlex="isFlex" :prestId="prestID" class="d-flex align-items-center w-100 h-100" />
				</div>
			</div>
			<PaymentCondition v-if="!specialStay" :paymentCondition="props.variant.paymentCondition" :cancellation-date="variant.cancelationUntil" :displayTitle="true" :isPVFlex="isFlex" :prestId="prestID" />
		</div>
		<div
			class="col-12 col-xl-6 px-0 d-flex flex-lg-row nowrap justify-content-end align-items-end"
		>
			<div
				class="d-flex flex-column d-lg-flex flex-lg-row justify-content-center align-items-center w-100 px-0 px-lg-2"
			>
				<div
					class="col-12 col-lg-7 px-0 pe-lg-1 d-lg-flex justify-content-end"
				>
					<Prices
						:isLoading="pricesLoadingSet.has(currentCacheKey)"
						:packCode="variant.codePackage"
						:crossedPrice="crossedPrice"
						:totalPrice="totalPrice"
						:perPrice="perPrice"
						:maxPromo="maxPromo"
						:locale="store.getters.locale"
					/>
					<span class="d-none d-lg-inline-block ps-lg-1 position-relative">
						<svg class="info-icon icon tf-icon-10 tf-icon-sm-20">
							<use xlink:href="#___icon___info"></use>
						</svg>
						<PackageDetalisPopUp
							:top="'0'"
							:left="'10px'"
						>
							{{ store.state.content.planner_prestationsPriceInfo }}
					</PackageDetalisPopUp>
					</span>
				</div>
				<div
					class="col-12 col-sm-6 col-lg-5 px-0 d-flex align-items-center justify-content-center accommodation-btn ms-lg-3"
				>
					<SelectButton
						:variant="variant"
						:selectedQuantity="selectedQuantity"
						:select_location="'prestation'"
						@selectClick="(id) => emit('select', id)"
						@dropdownClick="(obj) => emit('dropdownClick', obj)"
						@clear="(id) => emit('clear', id)"
						@dropdownSelect="
							({ newSelected, id }) =>
								emit('dropdownSelect', { newSelected, id })
						"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {
	withDefaults,
	defineProps,
	defineEmits,
	computed,
	ComputedRef,
} from "vue"

//import store from "@/vue/planning/store/store"
import Prices from "@/vue/planning/components/common/prices.vue"
import SelectButton from "@/vue/planning/components/result/selectBtn.vue"
import responsesCache from "@/vue/planning/state/responsesCache"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"
import currentCacheKey from "@/vue/planning/computed/currentCacheKey"
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue"
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";

// import FixFlexTag from "@/vue/planning/components/result/prestation/FixFlexTag.vue";


import { useStore } from "vuex"
const store = useStore();

import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
} from "@/logic/pricesAndDiscount"
import { getCancellationLastDate } from "@/vue/planning/logic/zeroCode"
import { isCS } from "@/vue/planning/logic/cs"

interface Props {
	variant: any
}
interface Emits {
	(e: "select", id: string): void
	(e: "clear", id: string): void
	(e: "dropdownSelect", selectedData: { newSelected: number; id: string }): void
	(e: "dropdownClick", obj: any): void
}

const props = withDefaults(defineProps<Props>(), {
	variant: {},
})
const emit = defineEmits<Emits>()

// computed
const selectedQuantity: ComputedRef<number> = computed(() => {
	return store.state.selectedPrestIds[props.variant.id]
})

const isFlex: ComputedRef<boolean> = computed(() => {
	return props.variant.pvFlex === "flex"
})

const crossedPrice: ComputedRef<number> = computed(() => {
	if (!props.variant) return NaN;
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
})

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
})

const totalPrice: ComputedRef<number> = computed(() => {
	return props.variant && getPrestTotalPrice(props.variant);
})

const maxPromo: ComputedRef<number> = computed(() => {
	return props.variant && getPrestMaxPromo(props.variant);
})
const cancellationLastDate: ComputedRef<string> = computed(() => {
	return getCancellationLastDate(props.variant, store.getters.locale)
})

const prestID: ComputedRef<string> = computed(() => {
	const isPvFlex = props.variant.pvFlex ? true : false
	const prestIDToDisplay = isPvFlex ? props.variant.prestIdSource : ""
	return prestIDToDisplay
})

const specialStay: ComputedRef<boolean> = computed(() => {
	// Original NL case
	const isNLSkiPass = props.variant && props.variant.isNewSkiPassValid;
	
	// FR case - only show skipass days if there are multiple variants with different skipass durations
	const hasMultipleSkipassDurations = props.variant && 
		store.getters.isLocaleFR && 
		props.variant.prestation && 
		props.variant.prestation.variants && 
		new Set(props.variant.prestation.variants
			.filter((v: { codePackage?: string }) => v.codePackage === props.variant.codePackage)
			.map((v: { skipass?: number }) => v.skipass))
		.size > 1;
		
	const isFRSkiPass = hasMultipleSkipassDurations && 
		(props.variant.skipass === 7 || props.variant.skipass === 8) && 
		(props.variant.codePackage === "PFTTF" || props.variant.codePackage === "PFPTTF");
		
	return (props.variant && isCS(props.variant)) || isNLSkiPass || isFRSkiPass;
});

</script>

<style scoped>
/* Handles packageDetailsPoup showing */

.info-icon:hover + .package-info-container {
	visibility: visible;
}

@media (max-width: 1400px) {
  .accommodation-btn {
    min-width: 16vw
  }

  .accommodation-btn button{
    margin-right: .20rem !important
  }
}
</style>
